import tw from "twin.macro";
export const SectionDescription = tw.p`mt-0 text-sm md:text-base lg:text-lg text-secondary-200 max-w-xl`;
export const MainPageDescription = tw.p`mt-4 md:text-left text-sm md:text-base lg:text-lg text-secondary-200 max-w-screen-sm`;
